"use strict";
// @ts-ignore
try {
    self['workbox:routing:7.3.0'] && _();
}
catch (e) { }
